import { createFileRoute } from "@tanstack/react-router";
import { LegalPolicyReview } from "@/features/legal/components/legal-policy";

function Page() {
  const { session } = Route.useRouteContext();
  return <LegalPolicyReview userId={session.user.id} />;
}

export const Route = createFileRoute("/_authenticated/_protected/legal")({ component: Page });
